// /**
//  * BCH Biometric Integration - WebAssembly Version
//  * 
//  * This code integrates with your web app to handle:
//  * - Registration: Convert distance vectors → ECC + helper + r → Store via API
//  * - Verification: Get helper data from DB → Correct errors → Match with r
//  */

// // Configuration
// // const NUM_DISTANCES = 316;
// // import BCHModule from "./bch_codec.js";
// // let BCHModule = null;




// const NUM_DISTANCES = 316;
// const BITS_PER_DISTANCE = 8;
// // const TOTAL_DATA_BITS = 316 * 8; // 808 bits
// const TOTAL_DATA_BITS = 316 * 8; // 808 bits
// const MAX_CORRECTABLE_ERRORS = Math.floor(TOTAL_DATA_BITS * 0.20); // 20% = ~161 bits

// // BCH parameters
// const BCH_M = 13;
// const BCH_T = 46;

// // WASM module state
// let bchModule = null;
// let bchControl = null;
// let wasmReady = false;

// async function loadBCHModule() {
//     console.log("Loading BCHModule script...");
//     return new Promise((resolve, reject) => {

//         const script = document.createElement("script");
//         script.src = "/bch_codec.js";
//         script.onload = async () => {
//             console.log("bch_codec.js loaded");

//             console.log("typeof window.BCHModule =", typeof window.BCHModule);

//             try {
//                 const module = await window.BCHModule({
//                     locateFile: (path) => {
//                         console.log("Loading WASM:", path, "→", `/${path}`);
//                         if (path.endsWith(".wasm")) return "/bch_codec.wasm";
//                         return `/bch_codec.js`;
//                     }
//                 });
//                 console.log(module.HEAP8);

//                 console.log("Module after instantiation:", module);

//                 resolve(module);
//             } catch (err) {
//                 console.error("WASM instantiation failed:", err);
//                 reject(err);
//             }
//         };

//         script.onerror = () => reject("Failed to load bch_codec.js");
//         document.body.appendChild(script);
//     });
// }

// /**
//  * Initialize BCH WebAssembly module
//  * Call this once when your app loads
//  */
// async function initBCH() {
//     if (wasmReady) return;

//     // Load WASM module (adjust path as needed)
//     bchModule = await loadBCHModule();

//     // Initialize BCH control structure (m=13, t=46, prim_poly=0)
//     console.log("Loaded keys:", Object.keys(bchModule));
//     console.log("module keys:", Object.keys(bchModule));
//     console.log("has ccall?", typeof bchModule.ccall);
//     console.log("has ccall?", typeof bchModule.ccall === "function");
//     console.log("has cwrap?", typeof bchModule.cwrap === "function");
//     console.log("has _malloc?", typeof bchModule._malloc === "function");
//     console.log("has HEAP8?", bchModule.HEAP8, "HEAPU8?", !!bchModule.HEAPU8);


//     bchControl = bchModule.ccall(
//         'init_bch',
//         'number',
//         ['number', 'number', 'number'],
//         [BCH_M, BCH_T, 0]
//     );

//     if (bchControl === 0 || !bchControl) {
//         throw new Error('Failed to initialize BCH codec');
//     }

//     wasmReady = true;
//     console.log('BCH module initialized');
// }

// /**
//  * Convert distance array (101 values, 0-255) to bit array
//  */
// function distancesToBits(distances) {
//     if (distances.length !== NUM_DISTANCES) {
//         throw new Error(`Expected ${NUM_DISTANCES} distances, got ${distances.length}`);
//     }

//     const bits = [];
//     for (let i = 0; i < distances.length; i++) {
//         const dist = Math.floor(distances[i]);
//         if (dist < 0 || dist > 255) {
//             throw new Error(`Distance ${i} must be 0-255, got ${dist}`);
//         }
//         // Convert to 8-bit binary (MSB first)
//         for (let bit = 7; bit >= 0; bit--) {
//             bits.push((dist >> bit) & 1);
//         }
//     }
//     return bits;
// }

// /**
//  * Convert bit array to distance array
//  */
// function bitsToDistances(bits) {
//     if (bits.length !== TOTAL_DATA_BITS) {
//         throw new Error(`Expected ${TOTAL_DATA_BITS} bits, got ${bits.length}`);
//     }

//     const distances = [];
//     for (let i = 0; i < NUM_DISTANCES; i++) {
//         let dist = 0;
//         for (let bit = 0; bit < BITS_PER_DISTANCE; bit++) {
//             const bitIdx = i * BITS_PER_DISTANCE + bit;
//             dist = (dist << 1) | (bits[bitIdx] & 1);
//         }
//         distances.push(dist);
//     }
//     return distances;
// }

// /**
//  * Generate random bits using crypto.getRandomValues
//  */
// function generateRandomBits(length) {
//     const bits = [];
//     const bytes = new Uint8Array(Math.ceil(length / 8));
//     crypto.getRandomValues(bytes);
//     for (let i = 0; i < length; i++) {
//         const byteIdx = Math.floor(i / 8);
//         const bitIdx = i % 8;
//         bits.push((bytes[byteIdx] >> (7 - bitIdx)) & 1);
//     }
//     return bits;
// }

// /**
//  * XOR two bit arrays
//  */
// function xorBits(a, b) {
//     if (a.length !== b.length) {
//         throw new Error(`Bit arrays must have same length`);
//     }
//     const result = [];
//     for (let i = 0; i < a.length; i++) {
//         result.push((a[i] ^ b[i]) & 1);
//     }
//     return result;
// }

// /**
//  * Calculate BCH ECC using WebAssembly
//  */
// async function calculateBCHECC(dataBits) {
//     if (!wasmReady) throw new Error('BCH not initialized. Call initBCH() first.');

//     const eccBits = bchModule.ccall('get_ecc_bits', 'number', ['number'], [bchControl]);

//     // Allocate memory for data bits (as bytes)
//     const dataBytes = Math.ceil(dataBits.length / 8);
//     const dataPtr = bchModule._malloc(dataBytes);
//     const dataView = new Uint8Array(bchModule.HEAP8.buffer, dataPtr, dataBytes);
//     dataView.fill(0);

//     // Pack bits into bytes (LSB first per byte)
//     for (let i = 0; i < dataBits.length; i++) {
//         const byteIdx = Math.floor(i / 8);
//         const bitIdx = i % 8;
//         if (dataBits[i]) {
//             dataView[byteIdx] |= (1 << bitIdx);
//         }
//     }

//     // Allocate memory for ECC
//     const eccBytes = Math.ceil(eccBits / 8);
//     const eccPtr = bchModule._malloc(eccBytes);
//     const eccView = new Uint8Array(bchModule.HEAP8.buffer, eccPtr, eccBytes);
//     eccView.fill(0);

//     // Call encodebits_bch
//     bchModule.ccall(
//         'encodebits_bch',
//         'void',
//         ['number', 'number', 'number'],
//         [bchControl, dataPtr, eccPtr]
//     );

//     // Extract ECC bits
//     const ecc = [];
//     for (let i = 0; i < eccBits; i++) {
//         const byteIdx = Math.floor(i / 8);
//         const bitIdx = i % 8;
//         ecc.push((eccView[byteIdx] >> bitIdx) & 1);
//     }

//     // Free memory
//     bchModule._free(dataPtr);
//     bchModule._free(eccPtr);

//     return ecc;
// }

// /**
//  * Decode and correct errors using BCH
//  */
// async function decodeAndCorrectBCH(dataBits, recvEcc) {
//     if (!wasmReady) throw new Error('BCH not initialized. Call initBCH() first.');

//     const eccBits = bchModule.ccall('get_ecc_bits', 'number', ['number'], [bchControl]);

//     // Allocate memory for data bits
//     const dataBytes = Math.ceil(dataBits.length / 8);
//     const dataPtr = bchModule._malloc(dataBytes);
//     const dataView = new Uint8Array(bchModule.HEAP8.buffer, dataPtr, dataBytes);
//     dataView.fill(0);

//     // Pack data bits
//     for (let i = 0; i < dataBits.length; i++) {
//         const byteIdx = Math.floor(i / 8);
//         const bitIdx = i % 8;
//         if (dataBits[i]) {
//             dataView[byteIdx] |= (1 << bitIdx);
//         }
//     }

//     // Allocate memory for received ECC
//     const recvEccBytes = Math.ceil(recvEcc.length / 8);
//     const recvEccPtr = bchModule._malloc(recvEccBytes);
//     const recvEccView = new Uint8Array(bchModule.HEAP8.buffer, recvEccPtr, recvEccBytes);
//     recvEccView.fill(0);

//     // Pack received ECC
//     for (let i = 0; i < recvEcc.length && i < eccBits; i++) {
//         const byteIdx = Math.floor(i / 8);
//         const bitIdx = i % 8;
//         if (recvEcc[i]) {
//             recvEccView[byteIdx] |= (1 << bitIdx);
//         }
//     }

//     // Allocate error location array
//     const maxErrors = BCH_T;
//     const errlocPtr = bchModule._malloc(maxErrors * 4);

//     // Decode
//     const numErrors = bchModule.ccall(
//         'decodebits_bch',
//         'number',
//         ['number', 'number', 'number', 'number'],
//         [bchControl, dataPtr, recvEccPtr, errlocPtr]
//     );

//     let correctedBits = [...dataBits];

//     if (numErrors > 0) {
//         // Correct errors
//         bchModule.ccall(
//             'correctbits_bch',
//             'void',
//             ['number', 'number', 'number', 'number'],
//             [bchControl, dataPtr, errlocPtr, numErrors]
//         );

//         // Extract corrected bits
//         correctedBits = [];
//         for (let i = 0; i < dataBits.length; i++) {
//             const byteIdx = Math.floor(i / 8);
//             const bitIdx = i % 8;
//             correctedBits.push((dataView[byteIdx] >> bitIdx) & 1);
//         }
//     }

//     // Free memory
//     bchModule._free(dataPtr);
//     bchModule._free(recvEccPtr);
//     bchModule._free(errlocPtr);

//     return {
//         correctedBits: correctedBits,
//         numErrors: numErrors >= 0 ? numErrors : 0
//     };
// }

// /**
//  * REGISTRATION WORKFLOW
//  * 
//  * Input: Distance vectors (101 values, 0-255) from biometric sensor
//  * Output: ECC bits, helper data, and r → Send to backend via API
//  */
// async function registerBiometric(distances) {
//     // 1. Convert distances to bits
//     const dataBits = distancesToBits(distances);

//     // 2. Generate random reference r (808 bits)
//     const r = generateRandomBits(TOTAL_DATA_BITS);

//     // 3. Calculate helper = data XOR r (this is stored, NOT raw distances)
//     const helper = xorBits(dataBits, r);

//     // 4. Calculate ECC for the data bits using BCH
//     const ecc = await calculateBCHECC(dataBits);

//     // 5. Prepare registration data
//     const registrationData = {
//         r: r,                    // Random reference (808 bits)
//         helper: helper,          // Helper data (808 bits) - NO raw distances
//         ecc: ecc,                // Error correction codes
//         timestamp: new Date().toISOString()
//     };

//     // 6. Send to backend via API
//     const response = await fetch('/api/biometric/register', {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(registrationData)
//     });

//     if (!response.ok) {
//         throw new Error('Registration API failed');
//     }

//     return await response.json();
// }

// /**
//  * VERIFICATION WORKFLOW
//  * 
//  * Input: Verification distance vectors (101 values, 0-255) from biometric sensor
//  * Process:
//  *   1. Get helper data, ECC, and r from backend
//  *   2. Reconstruct data using helper and verification vectors
//  *   3. Correct errors using BCH (up to 20% bit errors)
//  *   4. Match corrected data with stored r
//  * Output: true if match, false otherwise
//  */
// async function verifyBiometric(distances, userId) {
//     // 1. Get registration data from backend
//     const response = await fetch(`/api/biometric/registration/${userId}`, {
//         method: 'GET',
//         headers: {
//             'Content-Type': 'application/json',
//         }
//     });

//     if (!response.ok) {
//         throw new Error('Failed to get registration data');
//     }

//     const registrationData = await response.json();
//     // Expected: { r: [...], helper: [...], ecc: [...] }

//     // 2. Convert verification distances to bits
//     const verifBits = distancesToBits(distances);

//     // 3. Reconstruct original data: helper XOR verification_bits
//     // At registration: helper = original_data XOR r
//     // At verification: reconstructed = helper XOR verifBits
//     // If verifBits ≈ original_data, then reconstructed ≈ r
//     const reconstructedBits = xorBits(registrationData.helper, verifBits);

//     // 4. Correct errors using BCH (can correct up to 20% = ~161 bits)
//     const decodeResult = await decodeAndCorrectBCH(reconstructedBits, registrationData.ecc);

//     console.log(`Errors detected and corrected: ${decodeResult.numErrors}`);

//     // 5. Check if errors are within correction capability (20%)
//     if (decodeResult.numErrors > MAX_CORRECTABLE_ERRORS) {
//         return {
//             success: false,
//             reason: 'Too many errors',
//             numErrors: decodeResult.numErrors,
//             maxCorrectable: MAX_CORRECTABLE_ERRORS
//         };
//     }

//     // 6. Match corrected data with stored r
//     // If verification is successful, correctedBits should match r
//     const correctedData = decodeResult.correctedBits;
//     const storedR = registrationData.r;

//     // Compare corrected data with stored r
//     let matchCount = 0;
//     for (let i = 0; i < correctedData.length && i < storedR.length; i++) {
//         if (correctedData[i] === storedR[i]) {
//             matchCount++;
//         }
//     }

//     const matchPercentage = (matchCount / TOTAL_DATA_BITS) * 100;
//     const matchThreshold = 95; // 95% match required

//     const isMatch = matchPercentage >= matchThreshold;

//     return {
//         success: isMatch,
//         matchPercentage: matchPercentage,
//         numErrors: decodeResult.numErrors,
//         matchCount: matchCount,
//         totalBits: TOTAL_DATA_BITS
//     };
// }

// // Export functions for use in your app
// if (typeof window !== 'undefined') {
//     window.BCHBiometric = {
//         initBCH,
//         registerBiometric,
//         verifyBiometric,
//         NUM_DISTANCES,
//         MAX_CORRECTABLE_ERRORS
//     };
// }


/**
 * BCH Biometric Integration - WebAssembly Version (React-Compatible)
 *
 * IMPORTANT:
 * - Keeps ALL original workflows (initBCH, registerBiometric, verifyBiometric)
 * - Fixes WASM loading for Emscripten MODULARIZE=1
 * - Ensures React can call await BCHBiometric.initBCH()
 */

// Import CryptoJS for hash calculation
// This will work with webpack/bundler used by React
import CryptoJS from 'crypto-js';

// Configuration
const NUM_DISTANCES = 316;
const BITS_PER_DISTANCE = 8;
const TOTAL_DATA_BITS = NUM_DISTANCES * BITS_PER_DISTANCE;
const MAX_CORRECTABLE_ERRORS = Math.floor(TOTAL_DATA_BITS * 0.18);

// BCH parameters
const BCH_M = 13;
const BCH_T = 455; // Must be an integer

// WASM module state
let bchModule = null;
let bchControl = null;
let wasmReady = false;


async function loadBCHModule() {
    // console.log("Loading BCHModule script...");

    // Check if already loaded
    if (window.BCHModule) {
        // console.log("BCHModule already available");
        try {
            const module = await window.BCHModule({
                locateFile: (path) => {
                    // console.log("Loading WASM:", path, "→", `/${path}`);
                    if (path.endsWith(".wasm")) {
                        return "/bch_codec.wasm";
                    }
                    return `/${path}`;
                }
            });
            // console.log("Module after instantiation:", module);
            return module;
        } catch (err) {
            // console.error("WASM instantiation failed:", err);
            throw err;
        }
    }

    // Load script if not available
    return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = "/bch_codec.js";
        script.onload = async () => {
            // console.log("bch_codec.js loaded");
            // console.log("typeof window.BCHModule =", typeof window.BCHModule);

            if (typeof window.BCHModule !== "function") {
                reject(new Error("BCHModule not found after script load"));
                return;
            }

            try {
                const module = await window.BCHModule({
                    locateFile: (path) => {
                        // console.log("Loading WASM:", path, "→", `/${path}`);
                        if (path.endsWith(".wasm")) {
                            return "/bch_codec.wasm";
                        }
                        return `/${path}`;
                    }
                });
                // console.log("Module after instantiation:", module);
                resolve(module);
            } catch (err) {
                // console.error("WASM instantiation failed:", err);
                reject(err);
            }
        };

        script.onerror = () => reject(new Error("Failed to load bch_codec.js"));
        document.body.appendChild(script);
    });
}




/**
 * Initialize BCH WASM module
 */
async function initBCH() {
    if (wasmReady && bchModule) return;

    bchModule = await loadBCHModule();

    if (typeof bchModule.ccall !== "function") {
        // console.error("Module returned:", bchModule);
        throw new Error("bchModule.ccall is missing – WASM not initialized");
    }
    // console.log("WASM memory:", bchModule.HEAP8);
    // console.log("WASM exports:", Object.keys(bchModule));



    // init C structure
    bchControl = bchModule.ccall(
        "init_bch",
        "number",
        ["number", "number", "number"],
        [BCH_M, BCH_T, 0]
    );

    if (!bchControl) {
        throw new Error("init_bch returned NULL");
    }

    wasmReady = true;
    // console.log("BCH ready ✔");
}



/**
 * Normalize distance values to 0-255 range
 * Uses min-max normalization across all distances
 * @param {Array<number|string>} distances - Array of distance values
 * @returns {Array<number>} Normalized distances (0-255)
 */
function normalizeDistances(distances) {
    // Convert to numbers and find min/max
    const numDistances = distances.map(d => parseFloat(d) || 0);
    const minDist = Math.min(...numDistances);
    const maxDist = Math.max(...numDistances);
    const range = maxDist - minDist;

    // console.log(`Distance range: min=${minDist.toFixed(4)}, max=${maxDist.toFixed(4)}, range=${range.toFixed(4)}`);

    // Normalize to 0-255
    if (range === 0) {
        // All distances are the same, set to middle value
        return new Array(distances.length).fill(128);
    }

    return numDistances.map(dist => {
        // Normalize to 0-1, then scale to 0-255
        const normalized = (dist - minDist) / range;
        return Math.round(normalized * 255);
    });
}

/**
 * Convert distances → bits
 * @param {Array<number|string>} distances - Array of distance values (can be strings from .toFixed())
 * @returns {Array<number>} Array of bits (0 or 1)
 */
function distancesToBits(distances) {
    if (distances.length !== NUM_DISTANCES) {
        throw new Error(`Expected ${NUM_DISTANCES} distances, got ${distances.length}`);
    }

    const bits = [];
    // console.log("Converting distances to bits:", NUM_DISTANCES, "distances,", BITS_PER_DISTANCE, "bits each");

    // Normalize distances to 0-255 range
    const normalizedDistances = normalizeDistances(distances);

    for (let i = 0; i < normalizedDistances.length; i++) {
        const dist = normalizedDistances[i];

        if (dist < 0 || dist > 255) {
            throw new Error(`Distance ${i} must be in 0–255, got ${dist} (original: ${distances[i]})`);
        }

        // Convert to 8-bit binary (MSB first)
        for (let bit = 7; bit >= 0; bit--) {
            bits.push((dist >> bit) & 1);
        }
    }

    //  console.log(`Converted ${distances.length} distances to ${bits.length} bits`);
    return bits;
}

/**
 * Convert bits → distances
 */
function bitsToDistances(bits) {
    if (bits.length !== TOTAL_DATA_BITS)
        throw new Error(`Expected ${TOTAL_DATA_BITS} bits`);

    const distances = [];
    for (let i = 0; i < NUM_DISTANCES; i++) {
        let d = 0;
        for (let bit = 0; bit < BITS_PER_DISTANCE; bit++) {
            const b = bits[i * BITS_PER_DISTANCE + bit];
            d = (d << 1) | b;
        }
        distances.push(d);
    }
    return distances;
}



/**
 * Random bit generator
 */
function generateRandomBits(len) {
    const out = [];
    const bytes = new Uint8Array(Math.ceil(len / 8));
    crypto.getRandomValues(bytes);
    for (let i = 0; i < len; i++) {
        const byte = Math.floor(i / 8);
        const bit = 7 - (i % 8);
        out.push((bytes[byte] >> bit) & 1);
    }
    return out;
}

/**
 * XOR helper
 */
function xorBits(a, b) {
    // console.log("a.length", a.length)
    // console.log("b.length", b.length)
    if (a.length !== b.length)
        throw new Error("Bit arrays must be same length");
    return a.map((v, i) => v ^ b[i]);
}

/**
 * Calculate BCH ECC bits
 * @param {Array<number>} dataBits - Array of bits (0 or 1)
 */
async function calculateBCHECC(dataBits) {
    if (!wasmReady) throw new Error("BCH not initialized");

    const eccBits = bchModule.ccall(
        "get_ecc_bits",
        "number",
        ["number"],
        [bchControl]
    );

    // Get the expected data size: K = n - ecc_bits
    // For m=13: n = 2^13 - 1 = 8191, so K = 8191 - ecc_bits
    // We need to calculate K to ensure we pass the correct number of bits
    const n = Math.pow(2, BCH_M) - 1; // n = 2^m - 1
    const K = n - eccBits; // K = n - ecc_bits (number of data bits)

    // console.log(`BCH parameters: n=${n}, ecc_bits=${eccBits}, K=${K}, dataBits.length=${dataBits.length}`);

    // Pad or truncate dataBits to exactly K bits
    let processedBits = [...dataBits];
    if (processedBits.length < K) {
        // Pad with zeros at the end
        // console.log(`Padding ${K - processedBits.length} bits to match K=${K}`);
        processedBits = [...processedBits, ...new Array(K - processedBits.length).fill(0)];
    } else if (processedBits.length > K) {
        // Truncate to K bits
        //  console.log(`Truncating ${processedBits.length - K} bits to match K=${K}`);
        processedBits = processedBits.slice(0, K);
    }

    // encodebits_bch expects data as uint8_t array where each element is a bit (0 or 1)
    // The function reads data[k] & 1 to get the bit value
    const dataSize = K; // Use exactly K bits

    // Allocate memory for data bits (one byte per bit as expected by encodebits_bch)
    const dataPtr = bchModule._malloc(dataSize);
    if (!dataPtr) {
        throw new Error("Failed to allocate memory for data bits");
    }

    // Use HEAPU8 (unsigned) instead of HEAP8 (signed)
    const dataView = new Uint8Array(bchModule.HEAPU8.buffer, dataPtr, dataSize);

    // Copy bits to memory - each byte represents one bit (0 or 1)
    for (let i = 0; i < dataSize; i++) {
        dataView[i] = processedBits[i] ? 1 : 0;
    }

    // Allocate memory for ECC bits (one byte per bit)
    const eccPtr = bchModule._malloc(eccBits);
    if (!eccPtr) {
        bchModule._free(dataPtr);
        throw new Error("Failed to allocate memory for ECC bits");
    }

    const eccView = new Uint8Array(bchModule.HEAPU8.buffer, eccPtr, eccBits);
    eccView.fill(0);

    try {
        // Call encodebits_bch - it expects data and ecc as uint8_t arrays
        // where each element represents one bit
        bchModule.ccall(
            "encodebits_bch",
            "void",
            ["number", "number", "number"],
            [bchControl, dataPtr, eccPtr]
        );
    } catch (error) {
        bchModule._free(dataPtr);
        bchModule._free(eccPtr);
        throw new Error(`BCH encoding failed: ${error.message}`);
    }

    // Extract ECC bits from memory
    const ecc = [];
    for (let i = 0; i < eccBits; i++) {
        ecc.push(eccView[i] & 1); // Read LSB as the function stores it
    }

    bchModule._free(dataPtr);
    bchModule._free(eccPtr);

    return ecc;
}

/**
 * Decode & Correct BCH
 */
async function decodeAndCorrectBCH(dataBits, recvEcc) {
    if (!wasmReady) throw new Error("BCH not initialized");

    const eccBits = bchModule.ccall(
        "get_ecc_bits",
        "number",
        ["number"],
        [bchControl]
    );
    // console.log("eccBits", eccBits);
    const dataSize = dataBits.length;

    // Allocate memory for data bits (one byte per bit)
    const dataPtr = bchModule._malloc(dataSize);
    if (!dataPtr) {
        throw new Error("Failed to allocate memory for data bits");
    }

    const dataView = new Uint8Array(bchModule.HEAPU8.buffer, dataPtr, dataSize);
    for (let i = 0; i < dataSize; i++) {
        dataView[i] = dataBits[i] ? 1 : 0;
    }

    // Allocate memory for received ECC bits (one byte per bit)
    const recvPtr = bchModule._malloc(eccBits);
    if (!recvPtr) {
        bchModule._free(dataPtr);
        throw new Error("Failed to allocate memory for ECC bits");
    }

    const recvView = new Uint8Array(bchModule.HEAPU8.buffer, recvPtr, eccBits);
    for (let i = 0; i < eccBits && i < recvEcc.length; i++) {
        recvView[i] = recvEcc[i] ? 1 : 0;
    }

    // Allocate memory for error locations (array of unsigned int)
    const errlocPtr = bchModule._malloc(BCH_T * 4);
    if (!errlocPtr) {
        bchModule._free(dataPtr);
        bchModule._free(recvPtr);
        throw new Error("Failed to allocate memory for error locations");
    }

    let numErrors;
    try {
        numErrors = bchModule.ccall(
            "decodebits_bch",
            "number",
            ["number", "number", "number", "number"],
            [bchControl, dataPtr, recvPtr, errlocPtr]
        );
    } catch (error) {
        bchModule._free(dataPtr);
        bchModule._free(recvPtr);
        bchModule._free(errlocPtr);
        throw new Error(`BCH decoding failed: ${error.message}`);
    }

    let correctedBits = [...dataBits];

    if (numErrors > 0) {
        try {
            bchModule.ccall(
                "correctbits_bch",
                "void",
                ["number", "number", "number", "number"],
                [bchControl, dataPtr, errlocPtr, numErrors]
            );

            // Read corrected bits back
            correctedBits = [];
            for (let i = 0; i < dataSize; i++) {
                correctedBits.push(dataView[i] & 1);
            }
        } catch (error) {
            //    console.error("Error correction failed:", error);
        }
    }

    bchModule._free(dataPtr);
    bchModule._free(recvPtr);
    bchModule._free(errlocPtr);

    return {
        correctedBits,
        numErrors: Math.max(numErrors, 0)
    };
}

/**
 * Calculate average distances from multiple distance arrays
 * @param {Array<Array<number|string>>} distanceArrays - Array of distance arrays
 * @returns {Array<number>} Averaged distances (not normalized, will be normalized in distancesToBits)
 */
function averageDistances(distanceArrays) {
    if (distanceArrays.length === 0) {
        throw new Error("No distance arrays provided");
    }

    const numDistances = distanceArrays[0].length;
    const averaged = new Array(numDistances).fill(0);

    for (const distArray of distanceArrays) {
        if (distArray.length !== numDistances) {
            // console.warn(`Distance array length mismatch: expected ${numDistances}, got ${distArray.length}`);
            continue;
        }
        for (let i = 0; i < numDistances; i++) {
            averaged[i] += parseFloat(distArray[i]) || 0;
        }
    }

    // Average (keep as float, normalization happens in distancesToBits)
    for (let i = 0; i < numDistances; i++) {
        averaged[i] = averaged[i] / distanceArrays.length;
    }

    // console.log(`Averaged ${distanceArrays.length} distance arrays into one array of ${numDistances} distances`);
    return averaged;
}

/**
 * Pad or truncate bit array to target length
 * @param {Array<number>} bits - Input bit array
 * @param {number} targetLength - Target length
 * @param {boolean} padWithZeros - If true, pad with zeros; if false, truncate
 * @returns {Array<number>} Padded/truncated bit array
 */
function alignBits(bits, targetLength, padWithZeros = true) {
    if (bits.length === targetLength) {
        return [...bits];
    }

    if (bits.length < targetLength) {
        if (padWithZeros) {
            // Pad with zeros at the end
            return [...bits, ...new Array(targetLength - bits.length).fill(0)];
        } else {
            // Pad with zeros at the beginning
            return [...new Array(targetLength - bits.length).fill(0), ...bits];
        }
    } else {
        // Truncate to target length
        return bits.slice(0, targetLength);
    }
}

/**
 * Encode secret key bits using BCH to produce codeword
 * @param {Array<number>} secretKeyBits - Secret key bits (will be padded/truncated to K)
 * @returns {Promise<Array<number>>} Codeword bits (length n = K + ecc_bits)
 */
async function encodeSecretKeyBCH(secretKeyBits) {
    if (!wasmReady) throw new Error("BCH not initialized");

    const eccBits = bchModule.ccall(
        "get_ecc_bits",
        "number",
        ["number"],
        [bchControl]
    );

    const n = Math.pow(2, BCH_M) - 1; // n = 2^m - 1
    const K = n - eccBits; // K = n - ecc_bits (number of data bits)

    // Align secretKeyBits to exactly K bits
    const alignedSecretKey = alignBits(secretKeyBits, K, true);

    // Encode to get ECC bits
    const ecc = await calculateBCHECC(alignedSecretKey);

    // Codeword = data bits (K) + ECC bits (eccBits) = n bits total
    const codewordBits = [...alignedSecretKey, ...ecc];

    return codewordBits;
}

/**
 * Decode codeword bits using BCH to recover secret key
 * @param {Array<number>} codewordBits - Codeword bits (should be length n)
 * @returns {Promise<Array<number>>} Decoded secret key bits (length K)
 */
async function decodeCodewordBCH(codewordBits) {
    if (!wasmReady) throw new Error("BCH not initialized");

    const eccBits = bchModule.ccall(
        "get_ecc_bits",
        "number",
        ["number"],
        [bchControl]
    );

    const n = Math.pow(2, BCH_M) - 1; // n = 2^m - 1
    const K = n - eccBits; // K = n - ecc_bits

    // Align codewordBits to exactly n bits
    const alignedCodeword = alignBits(codewordBits, n, true);

    // Split into data bits and ECC bits
    const dataBits = alignedCodeword.slice(0, K);
    const recvEcc = alignedCodeword.slice(K, K + eccBits);

    // Decode and correct errors
    const decodeResult = await decodeAndCorrectBCH(dataBits, recvEcc);

    // Return corrected secret key bits
    return decodeResult.correctedBits.slice(0, K);
}

function xorHex(h1, h2) {
    if (h1.length !== h2.length) throw new Error("Length same honi chahiye");

    let out = "";
    for (let i = 0; i < h1.length; i += 2) {
        out += (
            (parseInt(h1.slice(i, i + 2), 16) ^
                parseInt(h2.slice(i, i + 2), 16))
        ).toString(16).padStart(2, "0");
    }
    return out;
}

/**
 * REGISTRATION WORKFLOW - BCH Fuzzy Extractor (Zero-Biometric)
 * 
 * Process:
 * 1. distances → biometricBits
 * 2. secretKeyBits = random bits (≥128 bits, aligned to K)
 * 3. codewordBits = BCH.encode(secretKeyBits)
 * 4. helperBits = codewordBits XOR biometricBitsAligned
 * 5. Store: helperBits + SHA256(secretKeyBits)
 * 
 * @param {Array<number|string>|Array<Array<number|string>>} distances - Single distance array or array of distance arrays
 * @param {Object} options - Optional parameters
 * @returns {Promise<Object>} Registration data with helper (string) and secretHash (hex string)
 */
async function registerBiometric(distances, salt, options = {}) {
    // Handle multiple distance arrays (average them)
    let processedDistances;
    if (Array.isArray(distances[0]) && Array.isArray(distances[0][0])) {
        processedDistances = averageDistances(distances);
    } else if (Array.isArray(distances[0]) && (typeof distances[0][0] === 'number' || typeof distances[0][0] === 'string')) {
        processedDistances = distances;
    } else {
        processedDistances = distances;
    }

    // Step 1: Convert distances to bits
    const biometricBits = distancesToBits(processedDistances);

    // Step 2: Generate random secret key (≥128 bits, aligned to K)
    // Get BCH parameters to determine K
    const eccBits = bchModule.ccall(
        "get_ecc_bits",
        "number",
        ["number"],
        [bchControl]
    );
    const n = Math.pow(2, BCH_M) - 1;
    const K = n - eccBits;

    // Generate secret key: use K bits (K is typically much larger than 128)
    // If K < 128, we'd need to handle that, but with m=13, K should be ~2276 bits
    const secretKeyBits = generateRandomBits(K);

    // Step 3: Encode secret key with BCH to get codeword
    const codewordBits = await encodeSecretKeyBCH(secretKeyBits);

    // Step 4: Align biometric bits to codeword length (n bits) and XOR
    const alignedBiometricBits = alignBits(biometricBits, codewordBits.length, true);
    const helperBits = xorBits(codewordBits, alignedBiometricBits);

    // Step 5: Compute SHA-256 hash of secret key for storage
    // Hash the secret key bits directly as a string for consistency
    const secretKeyBitsString = secretKeyBits.join('');
    const secretHash = CryptoJS.SHA256(secretKeyBitsString).toString(CryptoJS.enc.Hex);

    // Convert helper bits to string for storage
    const helperString = helperBits.join('');

    const k1 = xorHex(secretHash, salt);
    const k = CryptoJS.lib.WordArray.random(32).toString(CryptoJS.enc.Hex);
    const k2 = xorHex(k1, k);
    // Token calculation using hash to prevent XOR cancellation
    // token = SHA256(k || secretHash) ensures it only matches when both k and secretHash are correct
    const token = CryptoJS.SHA256(k + secretHash).toString(CryptoJS.enc.Hex);
    return {
        helper: helperString,  // Helper data: codeword XOR biometric (string format)
        token,
        k2,           // k2 = (secretHash XOR salt) XOR k
        timestamp: new Date().toISOString()
    };
}

/**
 * VERIFICATION WORKFLOW - BCH Fuzzy Extractor (Zero-Biometric)
 * 
 * Process:
 * 1. distances → biometricBits
 * 2. codewordPrime = helperBits XOR biometricBitsAligned
 * 3. secretPrime = BCH.decode(codewordPrime) [corrects errors]
 * 4. Compare SHA256(secretPrime) === storedSecretHash
 * 
 * @param {Array<number|string>} distances - Verification distance array
 * @param {Object|Array<Object>} registrationData - Registration data object or array of objects
 * @param {number} index - Optional index if registrationData is an array (default: 0)
 * @returns {Promise<Object>} Verification result
 */
async function verifyBiometric(distances, registrationData, salt, index = 0) {
    // Handle array of registration data objects
    // console.log("salt", salt);
    // console.log("registrationData", registrationData);
    let reg;
    if (Array.isArray(registrationData)) {
        if (index >= registrationData.length) {
            throw new Error(`Index ${index} out of bounds. Array has ${registrationData.length} items.`);
        }
        reg = registrationData[index];
    } else {
        reg = registrationData;
    }

    // Extract stored data
    if (!reg.helper || !reg.token || !reg.k2) {
        return {
            success: false,
            reason: "Missing registration data (helper, token, or k2)",
            matchPercentage: 0,
            registrationIndex: index
        };
    }

    // Convert helper string back to bit array
    let helperBits;
    if (typeof reg.helper === 'string') {
        helperBits = reg.helper.split('').map(bit => parseInt(bit, 10));
    } else {
        helperBits = [...reg.helper];
    }

    const storedToken = reg.token;
    const k2 = reg.k2;

    // Step 1: Convert verification distances to bits
    const biometricBits = distancesToBits(distances);

    // Step 2: Align biometric bits to helper length and XOR to get codeword
    const alignedBiometricBits = alignBits(biometricBits, helperBits.length, true);
    const codewordPrime = xorBits(helperBits, alignedBiometricBits);

    // Step 3: Decode codeword using BCH (this corrects errors)
    let secretPrime;
    try {
        secretPrime = await decodeCodewordBCH(codewordPrime);
    } catch (error) {
        return {
            success: false,
            reason: `BCH decoding failed: ${error.message}`,
            matchPercentage: 0,
            registrationIndex: index
        };
    }

    // Step 4: Compute SHA-256 hash of recovered secret key (same method as registration)
    const secretKeyBitsString = secretPrime.join('');
    const recoveredSecretHash = CryptoJS.SHA256(secretKeyBitsString).toString(CryptoJS.enc.Hex);
    console.log("recoveredSecretHash", recoveredSecretHash.substring(0, 16) + "...");
    console.log("salt", salt ? salt.substring(0, 16) + "..." : "not found");

    // Step 5: Verify token
    // Registration: token = SHA256(k || secretHash)
    // Verification: token' = SHA256(k' || recoveredSecretHash)
    // where k' = (recoveredSecretHash XOR salt) XOR k2
    // and k2 = (secretHash XOR salt) XOR k
    //
    // k' = (recoveredSecretHash XOR salt) XOR ((secretHash XOR salt) XOR k)
    // k' = recoveredSecretHash XOR secretHash XOR k
    //
    // token' = SHA256(k' || recoveredSecretHash)
    // token = SHA256(k || secretHash)
    //
    // token' will only equal token when:
    // 1. k' = k (which requires recoveredSecretHash = secretHash)
    // 2. recoveredSecretHash = secretHash
    //
    // This prevents cancellation because SHA256 is one-way and both inputs must match
    
    // Recover k' from k2 using the recovered secretHash
    const k1_prime = xorHex(recoveredSecretHash, salt);
    const k_recovered = xorHex(k1_prime, k2);
    
    // Calculate token using the same method as registration
    const token_prime = CryptoJS.SHA256(k_recovered + recoveredSecretHash).toString(CryptoJS.enc.Hex);
    
    console.log("k_recovered:", k_recovered.substring(0, 16) + "...");
    console.log("token' (computed):", token_prime.substring(0, 16) + "...");
    console.log("token (stored):", storedToken.substring(0, 16) + "...");
    
    const isMatch = token_prime === storedToken;
    
    console.log("Token match:", isMatch);
    
    if (isMatch) {
        console.log("✅ Verification successful: Token matches (k' and recoveredSecretHash are correct)");
    } else {
        console.log("❌ Verification failed: Token mismatch (k' or recoveredSecretHash is incorrect)");
    }

    return {
        success: isMatch,
        matchPercentage: isMatch ? 100 : 0,
        registrationIndex: index,
        hashMatch: isMatch,
        storedHash: storedToken.substring(0, 16) + "...",
        recoveredHash: recoveredSecretHash.substring(0, 16) + "..."
    };
}

// GLOBAL EXPORT
if (typeof window !== 'undefined') {
    window.BCHBiometric = {
        initBCH,
        registerBiometric,
        verifyBiometric,
        distancesToBits,
        bitsToDistances,
        averageDistances,
        normalizeDistances,
        NUM_DISTANCES,
        MAX_CORRECTABLE_ERRORS,
        TOTAL_DATA_BITS,
        BITS_PER_DISTANCE
    };
}

// Also export for ES6 modules if needed
export {
    initBCH,
    registerBiometric,
    verifyBiometric,
    distancesToBits,
    bitsToDistances,
    averageDistances,
    normalizeDistances,
    NUM_DISTANCES,
    MAX_CORRECTABLE_ERRORS,
    TOTAL_DATA_BITS,
    BITS_PER_DISTANCE
};
